import { defineCustomElement } from "vue";
import { Register } from "..";
import F360BagdeAvisoCe from "./F360Bagde.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-bagde")) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const CustomElement = defineCustomElement(F360BagdeAvisoCe as any);
      customElements.define("vc-bagde", CustomElement);
    }
  }
};

export default _register;
